import { Component } from "react";

import styles from "../app/styles/app-styles.scss"

// Icons
import IconRainfall from    "../app/assets/iconRainfall.png";
import IconPipeLevel from   "../app/assets/iconPipeLevel.png";
import IconOverflow from    "../app/assets/iconOverflow.png";
import IconTide from        "../app/assets/IconTide.png";

let iconsArray = [
    IconRainfall, IconPipeLevel, IconOverflow, IconTide
];

export default class extends Component{
    constructor(props, context){
        super(props, context);

        this.getStartPositionFromColumn = this.getStartPositionFromColumn.bind(this);
        this.getStartPositionFromRow = this.getStartPositionFromRow.bind(this);
    }

    getStartPositionFromColumn( columnSize, mapImageWidth){

        // we use a static width defined in app-styles.scss.
        // Let's import that variable and use it to determine the start position for the svg line.
        const siteWidth = parseInt(styles.siteWidth);
        let sitePadding = 15;

        switch( columnSize )
        {
            case 1:
                return sitePadding + (siteWidth/2);
            case 2:
                return mapImageWidth - (sitePadding + (siteWidth/2));
            default:
                return sitePadding;
        }
    }

    getStartPositionFromRow( rowSize){

        // we use a static height defined in app-styles.scss.
        // Let's import that variable and use it to determine the start position for the svg line.
        const siteHeight = parseInt(styles.siteHeight);
        const sitePadding = 15;

        switch( rowSize )
        {
            case 1:
                return sitePadding + (siteHeight/2);
            case 2:
                return (sitePadding*2) + (siteHeight) + (siteHeight/2);
            case 3:
                return (sitePadding*3) + (siteHeight*2) + (siteHeight/2);
            case 4:
                return (sitePadding*4) + (siteHeight*3) + (siteHeight/2);
            case 5:
                return (sitePadding*5) + (siteHeight*4) + (siteHeight/2);
            case 6:
                return (sitePadding*6) + (siteHeight*5) + (siteHeight/2);
            default:
                return sitePadding;
        }
    }

    render() {

        const { siteId,
            mapImageWidth,
            endLineX,
            endLineY,
            startPositionColumn,
            startPositionRow,
            siteType,
            showIcon } = this.props;

        return (
            <g>
                <line id={"for-site-" + siteId} className="site-path-1"
                      markerEnd={ (showIcon) ? "url(#arrowHeadForIcon)" : "url(#arrowHead)" }
                      x1={this.getStartPositionFromColumn(startPositionColumn, mapImageWidth)}
                      y1={this.getStartPositionFromRow(startPositionRow)}
                      x2={ endLineX }
                      y2={ endLineY }/>
                {/* note internet explorer doesn't support <circle fill="url(#pathToImage)"/> so had to use image tag instead. */}
                { showIcon &&
                    [
                        <image key="4" x={endLineX - 14} y={endLineY - 14} href={iconsArray[siteType-1]} height="30" width="30" />
                    ]
                }
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/site-path/site-path-component.js